/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Login_No_AccountInputs */

const en_auth_login_no_account = /** @type {(inputs: Auth_Login_No_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No account yet?`)
};

const pl_auth_login_no_account = /** @type {(inputs: Auth_Login_No_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie masz jeszcze konta?`)
};

/**
* | output |
* | --- |
* | "No account yet?" |
*
* @param {Auth_Login_No_AccountInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const auth_login_no_account = /** @type {((inputs?: Auth_Login_No_AccountInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Login_No_AccountInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_auth_login_no_account(inputs)
	return en_auth_login_no_account(inputs)
});